import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SECTIONS } from '../shared/section';
import { CARDS } from '../shared/card';
import { ButtonLinkComponent } from '../shared/button/button-link/button-link.component';
import { LISTS } from '../shared/list';
import { EVENT_TYPES, OFFERS, formatChf, getOffer, minPrice } from '../shared/data/offers.data';

@Component({
  selector: 'lumiron-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage, NgbCarouselModule, RouterModule, SECTIONS, CARDS, LISTS, ButtonLinkComponent],
})
export class HomeComponent {
  protected readonly eventTypes = EVENT_TYPES;
  protected readonly offers = OFFERS;
  protected readonly betreutFromChf = formatChf(minPrice(getOffer('betreut')).amount);
  protected readonly unbetreutFromChf = formatChf(minPrice(getOffer('unbetreut')).amount);
  protected readonly kidsFromChf = formatChf(minPrice(getOffer('kids')).amount);
}
